import { voucher } from "@/api/node";
import * as qiniu from "qiniu-js";

export function uploadFile(file, thiss) {
  return new Promise((resolve, reject) => {
    voucher()
      .then(res => {
        const putExtra = {};
        const config = {
          region: qiniu.region.z2
        };
        const observable = qiniu.upload(
          file,
          `avatar/${file.name}`,
          res.data,
          putExtra,
          config
        );

        // 返回 observable 让调用者可以订阅它
        return observable.subscribe({
          next(response) {
            let total = response.total;
            console.log(`Upload progress: ${Math.floor(total.percent)}%`);
            // 调用者可以通过订阅来处理进度
            // resolve(response.key);
            if (thiss.f.width) {
              thiss.msg = Math.floor(total.percent);
              thiss.f.width = Math.floor(thiss.msg) + "%";
            }
          },
          error(err) {
            console.error("Upload failed:", err);
            reject(err);
          },
          complete(res) {
            console.log("Upload completed:", res.key);
            resolve(res.key);
          }
        });
      })
      .catch(reject); // 处理 voucher 请求失败的情况
  });
}
